/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import settingPage from '../../sub-pages/setting-page';

const __vue_script__ = {
    name: 'ReadOnlyTimings',

    mixins: [settingPage],

    data() {
        return {
            allowedDurations: []
        };
    },

    methods: {
        async init() {
            const defaults = await this.$utils.controls.extractDefaults([this.registry['allowed-durations']], this.$services);
            this.allowedDurations = this.settings['allowed-durations'] || defaults['allowed-durations'];
        },

        save() {
            this.$emit('save', {
                'allowed-durations': this.allowedDurations
            });
        },

        getSettingsLinks() {
            const meetingsModule = this.$services.blueprint.getModuleByName('meetings');
            return this.$utils.modules.getRouteHref(meetingsModule, 'settings', { eventId: this.event._id });
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "form",
      staticClass: "read-only-timings",
      attrs: { tag: "form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
    },
    [
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("meetings.requests.settings.timing.general"))),
      ]),
      _c("fieldset", { staticClass: "info" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.$t("meetings.requests.settings.timing.info"))),
        ]),
        _c("p", [
          _vm._v(
            _vm._s(_vm.$t("meetings.requests.settings.timing.info2")) +
              "\n " +
              _vm._s(_vm.$t("general.meetings")) +
              " >"
          ),
          _c(
            "a",
            { attrs: { href: _vm.getSettingsLinks(), target: "_blank" } },
            [_vm._v(" " + _vm._s(_vm.$t("general.settings")))]
          ),
        ]),
      ]),
      _c("validation-provider", {
        attrs: { slim: true, name: "allowed-durations" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              return [
                _c("meta-control", {
                  attrs: {
                    name: "allowed-durations",
                    disabled: true,
                    settings: _vm.settings,
                    control: _vm.registry["allowed-durations"],
                    errors: errors,
                    event: _vm.event,
                  },
                  model: {
                    value: _vm.allowedDurations,
                    callback: function ($$v) {
                      _vm.allowedDurations = $$v
                    },
                    expression: "allowedDurations",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c("secondary-toolbar", [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [_vm._v(_vm._s(_vm.$t("general.save")))]
        ),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/sub-pages/ReadOnlyTimings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__